//여기있는 값은 서버와 함께 매핑되어 있습니다.
//새로 추가 되거나, 변경 될때는 id를 새로 만듭니다.
export const experienceItems = [
  {
    value: '주니어',
    value_en: 'Junior',
    value_ja: 'ジュニア',
    alt: '1',
    text: '주니어',
    id: 1,
  },
  {
    value: '시니어',
    value_en: 'Senior',
    value_ja: 'シニア',
    alt: '2',
    text: '시니어',
    id: 2,
  },
  {
    value: '스태프',
    value_en: 'Staff',
    value_ja: 'スタッフ',
    alt: '3',
    text: '스태프',
    id: 3,
  },
  {
    value: '매니저',
    value_en: 'Manager',
    value_ja: 'マネージャー',
    alt: '4',
    text: '매니저',
    id: 4,
  },
  {
    value: '시니어 매니저',
    value_en: 'Senior Manager',
    value_ja: 'シニアマネージャー',
    alt: '5',
    text: '시니어 매니저',
    id: 5,
  },
  {
    value: '디렉터',
    value_en: 'Director',
    value_ja: 'ディレクター',
    alt: '6',
    text: '디렉터',
    id: 6,
  },
  {
    value: 'VP',
    value_en: 'Vice President',
    value_ja: '副社長',
    alt: '7',
    text: 'VP',
    id: 7,
  },
  {
    value: 'C-Level',
    value_en: 'C-Level',
    value_ja: 'Cレベル',
    alt: '8',
    text: 'C-Level',
    id: 8,
  },
]

export const relationshipItems = [
  {
    value: '직장상사',
    value_en: 'Boss / Manager',
    value_ja: '上司',
    alt: '1',
    id: 1,
  },
  {
    value: '직장동료',
    value_en: 'Colleague',
    value_ja: '同僚',
    alt: '2',
    id: 2,
  },
  {
    value: '직장후임',
    value_en: 'Junior coworker',
    value_ja: '後輩',
    alt: '3',
    id: 3,
  },
  {
    value: '거래처',
    value_en: 'Client',
    value_ja: '取引先',
    alt: '4',
    id: 4,
  },
  {
    value: '외부파트너',
    value_en: 'External partner',
    value_ja: '外部パートナー',
    alt: '5',
    id: 5,
  },
]

export const intimacyItems = [
  {
    value: '아주 친밀해요',
    value_en: 'Very close',
    value_ja: 'とても親しい',
    alt: '1',
    id: 1,
  },
  {
    value: '친밀해요',
    value_en: 'Close',
    value_ja: '親しい',
    alt: '2',
    id: 2,
  },
  {
    value: '모르는 사이예요',
    value_en: 'Don’t know each other',
    value_ja: '知らない関係',
    alt: '3',
    id: 3,
  },
  {
    value: '불편해요',
    value_en: 'Uncomfortable',
    value_ja: '気まずい',
    alt: '4',
    id: 4,
  },
  {
    value: '아주 불편해요',
    value_en: 'Very uncomfortable',
    value_ja: 'とても気まずい',
    alt: '5',
    id: 5,
  },
]

export const toneItems = [
  {
    value: '까칠한, 예민한',
    value_en: 'Sharp, sensitive',
    value_ja: 'とげとげしい、敏感な',
    content:
      '문제는 제대로 파악했나요? 일정 관리는 어떻게 되고 있죠? 현실적으로 예측은 하고 있으신지 솔직히 의심스럽네요.',
    content_en:
      'Have you really understood the problem? How’s the schedule being managed? Honestly, I doubt you’ve made a realistic forecast.',
    content_ja:
      '問題はちゃんと把握していますか？スケジュール管理はどうなっています？正直、現実的に予測できているのか疑わしいですね。',
    alt: '1',
    id: 1,
  },
  {
    value: '따뜻한, 차분한',
    value_en: 'Warm, calm',
    value_ja: 'あたたかい、落ち着いた',
    content: '어서 와요! 일단 앉아요. 표정을 보니 고민이 꽤 깊어진 것 같은데... 천천히 말해봐요. 무슨 일이에요?',
    content_en:
      'Hey, welcome! Have a seat. From the look on your face, it seems like something’s been troubling you. Take your time—what’s going on?',
    content_ja:
      'いらっしゃい。まずは座ってください。表情を見ると、かなり悩んでいるようですね。ゆっくり話してください。どうしたんですか？',
    alt: '2',
    id: 2,
  },
  {
    value: '기운없는, 소심한',
    value_en: 'Low energy, timid',
    value_ja: '元気がない、内気な',
    content:
      '저기... 정말 죄송한데요... 자료... 혹시 한번만 더 확인해 주실 수 있을까요? 제가 본 것과 조금 다른 것 같아서... 제가 잘못 봤을 수도 있어요.',
    content_en:
      "Um... I'm really sorry, but... could you maybe check the file one more time...? I think it looked a bit different to me... I might’ve misread it.",
    content_ja:
      'あの...本当にすみませんが...資料をもう一度だけ確認していただけませんか？私が見たのとちょっと違う気がして...私の見間違いかもしれませんが...',
    alt: '3',
    id: 3,
  },
  {
    value: '밝은, 활기찬',
    value_en: 'Bright, energetic',
    value_ja: '明るい、元気な',
    content: '안녕하십니까! 좋은 아침입니다! 오늘 날씨 완전 좋네요!',
    content_en: 'Hello! Good morning! The weather is amazing today!',
    content_ja: 'おはようございます！今日は本当にいい天気ですね！',
    alt: '4',
    id: 4,
  },
]

export const ageItems = [
  {
    value: '20대',
    value_en: '20s',
    value_ja: '20代',
    alt: '1',
    id: 1,
  },
  {
    value: '30대',
    value_en: '30s',
    value_ja: '30代',
    alt: '2',
    id: 2,
  },
  {
    value: '40대',
    value_en: '40s',
    value_ja: '40代',
    alt: '3',
    id: 3,
  },
  {
    value: '50대',
    value_en: '50s',
    value_ja: '50代',
    alt: '4',
    id: 4,
  },
  {
    value: '60대+',
    value_en: '60+',
    value_ja: '60代以上',
    alt: '5',
    id: 5,
  },
]

export const genderItems = [
  {
    value: '여성',
    value_en: 'Female',
    value_ja: '女性',
    alt: '1',
    id: 1,
  },
  {
    value: '남성',
    value_en: 'Male',
    value_ja: '男性',
    alt: '2',
    id: 2,
  },
]

export const pronunciationItems = [
  {
    value: '미국',
    value_en: 'American',
    value_ja: 'アメリカ',
    alt: '1',
    id: 1,
  },
  {
    value: '영국',
    value_en: 'British',
    value_ja: 'イギリス',
    alt: '2',
    id: 2,
  },
  {
    value: '미국 동부',
    value_en: 'Eastern American',
    value_ja: 'アメリカ東部',
    alt: '3',
    id: 3,
  },
  {
    value: '미국 서부',
    value_en: 'Western American',
    value_ja: 'アメリカ西部',
    alt: '4',
    id: 4,
  },
  {
    value: '호주',
    value_en: 'Australian',
    value_ja: 'オーストラリア',
    alt: '5',
    id: 5,
  },
  {
    value: '싱가포르',
    value_en: 'Singaporean',
    value_ja: 'シンガポール',
    alt: '6',
    id: 6,
  },
  {
    value: '인도',
    value_en: 'Indian',
    value_ja: 'インド',
    alt: '7',
    id: 7,
  },
]

export const companyTypeItems = [
  {
    value: '빅테크',
    value_en: 'Big Tech',
    value_ja: 'ビッグテック',
    alt: '1',
    id: 1,
  },
  {
    value: '대기업',
    value_en: 'Large enterprise',
    value_ja: '大企業',
    alt: '2',
    id: 2,
  },
  {
    value: '중견기업',
    value_en: 'Mid-sized company',
    value_ja: '中堅企業',
    alt: '3',
    id: 3,
  },
  {
    value: '중소기업',
    value_en: 'Small business',
    value_ja: '中小企業',
    alt: '4',
    id: 4,
  },
  {
    value: '스타트업',
    value_en: 'Startup',
    value_ja: 'スタートアップ',
    alt: '5',
    id: 5,
  },
]
